// Local storage handling

export const getUser = () => {
  const storedUser = localStorage.getItem("user");
  return JSON.parse(storedUser);
};

export const setUser = (data) => {
  const userData = JSON.stringify(data);
  localStorage.setItem("user", userData);
};

export const removeUser = () => {
  localStorage.removeItem("user");
};
